export default __webpack_public_path__ + "static/media/Roboto-LightItalic.74ca8374.ttf";